export default {
  statistics: {
    total_followers: 'Follower totali',
    emails_sent: 'E-mail inviate',
    emails_opened: 'E-mail aperte',
    emails_clicked: 'E-mail cliccate',
    emails_average_open_rate: 'Tasso di apertura e-mail',
    emails_average_click_rate: 'Tasso di clic e-mail',
    push_notifications_sent: 'Notifiche push inviate',
    push_notifications_clicked: 'Notifiche push cliccate',
  },
};
